import { useEffect } from 'react';

const useClickOutside = (el, cb) => {
  useEffect(
    () => {
      const handleClick = e => !el.contains(e.target) && cb();
      window.addEventListener('click', handleClick);
      return () => window.removeEventListener('click', handleClick);
    },
    [el]
  );
};

export default useClickOutside;
